import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { axiosInstance } from '../helpers'

export type FurnitureInstallVendor = 'D12' | 'ISL' | 'SW'

export interface FurnitureInstallUploadRequest {
    file: File
    vendorFormat: FurnitureInstallVendor
    inspectionName: string
}

export interface FurnitureInstallUploadResult {
    inspection_id: number
    inspection_type_id: number
    inventory_configs_created: number
    units_matched: number
    unit_names: string[]
    area_inspections_created: number
    inventory_inspections_created: number
    warnings: string[]
}

interface UploadError {
    errors?: string[]
    detail?: string
}

export const useFurnitureInstallUpload = () => {
    const mutation = useMutation({
        mutationFn: async ({
            file,
            vendorFormat,
            inspectionName,
        }: FurnitureInstallUploadRequest) => {
            const form = new FormData()
            form.append('file', file)
            form.append('vendor_format', vendorFormat)
            form.append('inspection_name', inspectionName.trim())
            const {
                data,
            } = await axiosInstance.post<FurnitureInstallUploadResult>(
                'apt_config/furniture-install/upload/',
                form,
                { headers: { 'Content-Type': 'multipart/form-data' } },
            )
            return data
        },
    })

    const error = mutation.error as AxiosError<UploadError> | null
    const errors =
        error?.response?.data?.errors ||
        (error?.response?.data?.detail
            ? [error.response.data.detail]
            : error
            ? [error.message]
            : [])

    return {
        upload: mutation.mutateAsync,
        result: mutation.data,
        errors,
        isUploading: mutation.isLoading,
        reset: mutation.reset,
    }
}
